import * as React from 'react'
import axios from 'axios'
import queryString from 'query-string'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'

import './../styles/auth/auth.css'
import logo from './../images/logo.png'
import {Button, TYPES} from './../components/shared/button'


class PasswordResetConfirm extends React.Component {
  constructor() {
    super()

    this.state={
      new_password1: '',
      new_password2: '',
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState(queryString.parse(this.props.location.search))
  }

  toast = () => {
    toastr.removeByType('error')
    toastr.success('Success', 'Password Reset')
    this.props.history.push(`/login`)
  }

  handleSubmit(event) {
    event.preventDefault()
    axios.post(
      '/rest-auth/password/reset/confirm/',
      { ...this.state },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ).then(response => {
      this.toast()
    }).catch(error => {
      const passwordErrors = error.response.data.new_password2
      for (var i = 0; i < passwordErrors.length; i++) {
        const response = error.response.data.new_password2[i]
        toastr.error('Invalid Password', response)
      }
    })
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  authForm = () => {
    return (
        <div className='auth-box'>
        <img src={logo} alt='BayWatch Technologies' />
          <form onSubmit={this.handleSubmit} >
            <input type='password' placeholder='New Password' name='new_password1' onChange={this.handleChange} className='auth-input'/>
            <input type='password' placeholder='Confirm Password' name='new_password2' onChange={this.handleChange} className='auth-input'/>
            <div className='auth-button-container'>
              <Button
                text='Reset Password'
                type='logIn'
                buttonType={TYPES.SUBMIT}
              />
            </div>
          </form>
        </div>
    )
  }

  render () {
    return (
      <div className='auth-container'>
       {this.authForm()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect( mapStateToProps )( PasswordResetConfirm )



// WEBPACK FOOTER //
// ./src/pages/passwordResetConfirm.js